export default [
  {
    path: "/employer",
    name: "employer",
    meta: {
      title: "新上雇主",
      requireAuth: true
    },
    component: () => import("./employer.vue")
  },
  {
    path: "/employerDetail/:id",
    name: "employerDetail",
    meta: {
      title: "公司主页"
    },
    component: () => import("./detail.vue")
  }
];
